module.exports = __webpack_public_path__ + "img/75.13c64070.jpg";